export default "__VITE_ASSET__BS8jDeLy__"